import { call, put, takeLatest } from 'redux-saga/effects';
import { myautoiqNurturingJourneySettingsActions } from 'app/pages/MyautoiqNurturingJourneySettingsComponent/slice';
import { fetchMyautoiqNurturingJourneySettings } from './data/myautoiqNurturingJourneySettingsDataService';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

function* fetchMyautoiqNurturingJourneySettingsSaga(action: ReturnType<any>) {
  try {
    const response = yield call(fetchMyautoiqNurturingJourneySettings, {
      manufacturerId: action.payload.manufacturerId,
      makeId: action.payload.makeId,
    });
    yield put(
      myautoiqNurturingJourneySettingsActions.requestMyautoiqNurturingJourneySettingsSuccess(
        response,
      ),
    );
  } catch (error: any) {
    const message =
      error?.message || 'Myautoiq nurturing journey settings fetch failed';
    yield put(
      myautoiqNurturingJourneySettingsActions.requestMyautoiqNurturingJourneySettingsError(
        message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message,
      }),
    );
  }
}

export function* watchMyautoiqNurturingJourneySettingsSaga() {
  yield takeLatest(
    myautoiqNurturingJourneySettingsActions.requestMyautoiqNurturingJourneySettings.type,
    fetchMyautoiqNurturingJourneySettingsSaga,
  );
}
